import { RatingJobsActionTypes } from './constants';

export const INIT_STATE = {
    launchingRatingJob: false,
    gettingRatingJobStatus: false,
    stoppingRatingJob: false,
    restartingRatingJob: false,
    ratingJobStatus: null,
    ratingJobs: [],
};

type RatingJobsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    launchingRatingJob: boolean,
    gettingRatingJobStatus: boolean,
    stoppingRatingJob: boolean,
    restartingRatingJob: boolean,
    ratingJobStatus: string,
    ratingJobs: [],
};

const RatingJobs = (state: State = INIT_STATE, action: RatingJobsAction): any => {
    switch (action.type) {
        case RatingJobsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RatingJobsActionTypes.LAUNCH_RATING_JOB: {
                    return { ...state, launchingRatingJob: false };
                }
                case RatingJobsActionTypes.GET_RATING_JOB_STATUS: {
                    return { ...state, gettingRatingJobStatus: false, ratingJobStatus: action.payload.data };
                }
                case RatingJobsActionTypes.STOP_RATING_JOB: {
                    return { ...state, stoppingRatingJob: false };
                }
                case RatingJobsActionTypes.RESTART_RATING_JOB: {
                    return { ...state, restartingRatingJob: false };
                }
                case RatingJobsActionTypes.GET_ALL_RATING_JOBS: {
                    return { ...state, ratingJobs: action.payload.data };
                }
                default:
                    return { ...state, launchingRatingJob: false, stoppingRatingJob: false, restartingRatingJob: false, gettingRatingJobStatus: false, ratingJobStatus: null, ratingJobs: [] };
            }

        case RatingJobsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case RatingJobsActionTypes.LAUNCH_RATING_JOB: {
                    return { ...state, launchingRatingJob: false, error: action.payload.error };
                }
                case RatingJobsActionTypes.GET_RATING_JOB_STATUS: {
                    return { ...state, gettingRatingJobStatus: false, ratingJobStatus: null, error: action.payload.error };
                }
                case RatingJobsActionTypes.STOP_RATING_JOB: {
                    return { ...state, stoppingRatingJob: false, error: action.payload.error };
                }
                case RatingJobsActionTypes.RESTART_RATING_JOB: {
                    return { ...state, restartingRatingJob: false, error: action.payload.error };
                }
                case RatingJobsActionTypes.GET_ALL_RATING_JOBS: {
                    return { ...state, ratingJobs: [], error: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case RatingJobsActionTypes.LAUNCH_RATING_JOB:
            return { ...state, launchingRatingJob: true };
        case RatingJobsActionTypes.GET_RATING_JOB_STATUS:
            return { ...state, gettingRatingJobStatus: true, ratingJobStatus: null };
        case RatingJobsActionTypes.STOP_RATING_JOB:
            return { ...state, stoppingRatingJob: true };
        case RatingJobsActionTypes.RESTART_RATING_JOB:
            return { ...state, restartingRatingJob: true };
        case RatingJobsActionTypes.GET_ALL_RATING_JOBS:
            return { ...state, ratingJobs: [], gettingRatingJobStatus: true, ratingJobStatus: null };
        default:
            return { ...state };
    }
};

export default RatingJobs;
